import { Injectable } from "@angular/core";
import { AllUserData } from "@core/models/allusersData";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { storeAllUserDataAction } from "./allUsers.action";


export class USerDataStoreModel{
    userData: AllUserData[]
}
@State<USerDataStoreModel>({
    name: 'AllUserData',
    defaults: {
      userData: null
     }
})
@Injectable()
export class userDataState {

    constructor( ) { }

    @Selector()
    static getallUsererData(state: USerDataStoreModel) {
        return state.userData;
    }
    @Action(storeAllUserDataAction)
    storeAllUserDataAction({getState, patchState}: StateContext<USerDataStoreModel>, {payload}: storeAllUserDataAction) {

        const state = getState();
        patchState({
            
            userData:payload
        });

        
    }
}